export function initMainNavOverlay() {
  const mainNavOverlayEl = document.getElementById('mainNavigationOverlay');

  if (!mainNavOverlayEl) return;

  mainNavOverlayEl.addEventListener('click', () => {
    mainNavOverlayEl.dispatchEvent(new CustomEvent('toujou-event-nav-close', {
      bubbles: true,
      composed: true
    }));
  });
}
